<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-card elevation="4" color="#EFEBE9" class="px-3 my-5">
        <v-row>
          <v-col cols="12">
            <v-tabs
              v-model="tab"
              background-color="warning"
              dark
              icons-and-text
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab>
                EMail
                <v-icon>mdi-email</v-icon>
              </v-tab>

              <v-tab>
                SMS
                <v-icon>mdi-message</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
              <v-tab-item>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headersemail"
                  :items="listingEmailData"
                  :items-per-page="10"
                  :search="searchemail"
                  :single-expand= "singleExpand"
                  show-expand
                  :expanded.sync="expandedemail"
                  item-key="id"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="searchemail"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.date="{ item }">
                    <span>{{ formatDate(item.date, "DD-MMM-YY HH:mm:ss") }}</span>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <span v-html="item.description"></span>
                    </td>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headerssms"
                  :items="listingSMSData"
                  :items-per-page="10"
                  :search="searchsms"
                  :single-expand= "singleExpand"
                  show-expand
                  :expanded.sync="expandedsms"
                  item-key="id"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="searchsms"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.date="{ item }">
                    <span>{{ formatDate(item.date, "DD-MMM-YY HH:mm:ss") }}</span>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <span v-html="item.description"></span>
                    </td>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";
import { formatDate } from "../util/helpers";
import { showSnackbar } from "../util/globalActions";
export default {
  name: "CommunicationLogView",

  data: () => ({
    tab: null,
    tableLoading: false,
    modal: false,
    fromDate: null,
    toDate: null,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    expandedemail: [],
    expandedsms: [],
    singleExpand: true,
    searchemail: "",
    searchsms: "",
    listingEmailData: [],
    listingSMSData: [],
    message: "",
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headersemail: [
      {
        value: "id",
        text: "Sr.No.",
        width: "100px",
      },
      {
        text: "Date",
        value: "date",
        width: "120px",
      },
      {
        value: "phonemail",
        text: "Recipient",
        width: "100px",
      },
      {
        value: "usr",
        text: "Sent By",
        width: "100px",
      },
    ],
    headerssms: [
      {
        value: "id",
        text: "Sr.No.",
        width: "100px",
      },
      {
        text: "Date",
        value: "date",
        width: "120px",
      },
      {
        value: "phonemail",
        text: "Recipient",
        width: "100px",
      },
      {
        value: "description",
        text: "SMS Description",
        width: "150px",
      },
      
      {
        value: "usr",
        text: "Sent By",
        width: "100px",
      },
    ],
  }),
  created() {
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatDate,
    showData() {
      const self = this;
      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;

      axios({
        url: self.apiUrl + "api/Communication/GetCommunication",

        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingEmailData = res.data.filter(
            (item) => item.type.toLowerCase() === "email"
          );
          self.listingSMSData = res.data.filter(
            (item) => item.type.toLowerCase() === "sms"
          );
          self.tableLoading = false;
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
  },
};
</script>
